import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import RoutesConfig from './routes';
import Header from './components/Header';
import Footer from './components/Footer';

export default function App() {
  const { t, i18n } = useTranslation();
  const currentLang = (i18n.language || 'zh').split('-')[0] === 'en' ? 'en' : 'zh';
  return (
    <>
      <Helmet>
        <html lang={currentLang} />
        <title>{t('site.title', 'BTBP')}</title>
        <link
          rel="alternate"
          type="text/plain"
          href="/llms.txt"
          title="LLM-readable site index"
        />
      </Helmet>
      <Header />
      <Suspense fallback={<div style={{ padding: 40 }}>Loading...</div>}>
        <RoutesConfig currentLang={currentLang} />
      </Suspense>
      <Footer />
    </>
  );
}


